import React from 'react';


import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import MyCard from './MyCard.js';

import Exercices from './exercices/Exercices.js';
import EX1secondaire from './exercices/EX1secondaire.js';
import EX2secondaire from './exercices/EX2secondaire.js';
import EX3secondaire from './exercices/EX3secondaire.js';

import Exam from './exam/Exam.js';
import ExamScExpe from './exam/ExamScExpe.js';
import Exam3eme from './exam/Exam3eme.js';
import ExamSwitch from './exam/ExamSwitch.js';
import ExamScMaths from './exam/ExamScMaths';
import Exam3emeLocal from './exam/Exam3emeLocal';
import Exam3emeRegional from './exam/Exam3emeRegional';


import Cours from './cours/Cours.js';
import Cours1er from './cours/Cours1er.js';


import Devoir from './devoir/Devoir.js';
import Devoir3eme from './devoir/Devoir3eme.js';
import Devoir2eme from './devoir/Devoir2eme.js';
import Devoir1er from './devoir/Devoir1er.js';


import Olympiad from './olympiad/Olympiad.js';
import Home from './home/Home.js'
import NoMatch from './../NoMatch.js';
import AndroidApps from './androidapps/AndroidApps.js';
import NotReady from './NotReady.js';

import {
  BrowserRouter as Router,
  Switch,
  Route,
  Link,
  Redirect,
} from "react-router-dom";

class Click extends React.Component{
  render(){
    return (
    <Switch>
        <Route exact path="/" key="1" children={<Home />} />
        <Route path="/exercices" key="2" children={<Exercices />} />
        <Route path="/maths/1/exercices" key="7" children={<EX1secondaire />} />
        <Route path="/maths/2/exercices" key="9" children={<EX2secondaire />} />
        <Route path="/maths/3/exercices" key="10" children={<EX3secondaire />} />

        <Route path="/maths/4/exercices" key="16" children={<NotReady />} />
        <Route path="/maths/5/exercices" key="17" children={<NotReady />} />
        <Route path="/maths/6/exercices" key="18" children={<NotReady />} />

        <Route path="/cours" key="3" children={<Cours />} />
        <Route path="/maths/1/cours" key="31" children={<NotReady />} />
        <Route path="/maths/2/cours" key="32" children={<Cours1er />} />
        <Route path="/maths/3/cours" key="33" children={<NotReady />} />
        <Route path="/maths/4/cours" key="34" children={<NotReady />} />
        <Route path="/maths/5/cours" key="35" children={<NotReady />} />
        <Route path="/maths/6/cours" key="36" children={<NotReady />} />

        <Route path="/exam" key="4" children={<Exam />} />
        <Route path="/maths/bac-2/examen" key="13" children={<ExamSwitch />} />
        <Route path="/maths/bac-2/science-experimentale/examen" key="11" children={<ExamScExpe />} />
        <Route path="/maths/bac-2/science-maths/examen" key="11" children={<ExamScMaths />} />

        <Route path="/maths/3-eme/examen" key="12" children={<Exam3eme />} />
        <Route path="/maths/3-eme/regional/examen" key="14" children={<Exam3emeRegional />} />
        <Route path="/maths/3-eme/locale/examen" key="15" children={<Exam3emeLocal />} />

        <Route path="/devoir" key="5" children={<Devoir />} />
        <Route path="/maths/1/devoirs" key="19" children={<Devoir1er />} />
        <Route path="/maths/2/devoirs" key="20" children={<Devoir2eme />} />
        <Route path="/maths/3/devoirs" key="21" children={<Devoir3eme />} />
        <Route path="/maths/4/devoirs" key="22" children={<NotReady />} />
        <Route path="/maths/5/devoirs" key="23" children={<NotReady />} />
        <Route path="/maths/6/devoirs" key="24" children={<NotReady />} />





        <Route path="/olympiad" key="6" children={<Olympiad />} />
        <Route path="/maths/1/olympiad" key="25" children={<NotReady />} />
        <Route path="/maths/2/olympiad" key="26" children={<NotReady />} />
        <Route path="/maths/3/olympiad" key="27" children={<NotReady />} />
        <Route path="/maths/4/olympiad" key="28" children={<NotReady />} />
        <Route path="/maths/5/olympiad" key="29" children={<NotReady />} />
        <Route path="/maths/6/olympiad" key="30" children={<NotReady />} />



        <Route path="/programmation" key="7" children={<AndroidApps />} />
        <Route path="*" key="8" children={<NoMatch />} />
    </Switch>
  );
  }
}

export default Click;
